import Button from '../../../../../components/Button'
import useResize from '../../../../../hooks/useResize'
import { VIEWPORT_LG } from '../../../../../utils/constants'
import RayIcon from '../../../icons/RayIcon'
import RibbonIcon from '../../../icons/RibbonIcon'
import WorldIcon from '../../../icons/WorldIcon'
import { useHutritClubUploadTalentStore } from '../../globalStore'
import TipItem from '../../smallComponents/TipItem'

const Explanations = () => {
  const { currentStep, setCurrentStep } = useHutritClubUploadTalentStore()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG

  const HUTRIT_CLUB_TIP_ITEMS_LIST = [
    {
      id: 1,
      icon: <WorldIcon />,
      text: (
        <>
          Dar el primer paso para entrar en el <br /> mercado laboral con
          ventaja.
        </>
      ),
    },
    {
      id: 2,
      icon: <RibbonIcon />,
      text: ' Enseñar a las empresas de qué eres capaz.',
    },
    {
      id: 3,
      icon: <RayIcon />,
      text: (
        <>
          Mostrar que no necesitas que te digan qué <br /> hacer: tú propones,
          tú ejecutas.
        </>
      ),
    },
  ]

  const handleAdvanceStep = () => {
    setCurrentStep(currentStep + 1)
  }

  return (
    <div className="d-flex flex-column align-items-center">
      <h1
        className={`${
          isMobile ? 'fontSize24' : 'fontSize40'
        } text-on-bg-primary fw-bold text-center`}
      >
        ¡Prepárate para hacer el reto de Hutrit Club!
      </h1>
      <h2
        className={`${
          isMobile ? 'fontSize14' : 'fontSize24'
        } text-on-bg-primary pt-3 text-center`}
      >
        Si has llegado hasta aquí, es porque tienes algo especial. Pero ahora
        viene lo <br /> importante: <strong>demostrarlo</strong>.
      </h2>
      <div
        className={`${
          isMobile ? 'px-3 mx-3' : 'px120'
        } py-4 d-flex flex-column align-items-center border border-2 rounded mt-5`}
      >
        <h2 className="text-on-bg-primary text-center fw-bold">
          Este reto no es solo una prueba técnica. Es una <br /> oportunidad
          para:
        </h2>
        <div className="d-flex flex-column align-items-start gap-3 mt-4">
          {HUTRIT_CLUB_TIP_ITEMS_LIST.map(({ id, icon, text }) => (
            <TipItem key={id} icon={icon} text={text} />
          ))}
        </div>
      </div>
      <Button
        className="btn-bg-CTA-primary text-on-bg-primary p-3 mt-4"
        onClick={handleAdvanceStep}
      >
        Comenzar ahora
      </Button>
    </div>
  )
}

export default Explanations
